import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

function Building_Sanction_Circular_2015_16() {
  return (
    <TableStructure
      list={[
        {
          date: "03/03/2016",
          subject:
            "Submission of Site Co-ordinated and site elevation certificate by LBS/Architect as required for height clearance from AAI Circular No. 15 of 2015-16",
          fileStoreId: "a8bf70c4-10b9-4ae8-8a4f-f6d55bfe3cfd",
          label: "DG(BLDG)'s Circular No. 15 of 2015-16",
        },
        {
          date: "09/03/2016",
          subject:
            "To cover the construction to avoid mixing of dust particles in the air Circular No. 14 of 2015-16",
          fileStoreId: "c806320b-36da-4f56-8012-9290b651b90c",
          label: "DG(BLDG)'s Circular No. 14 of 2015-16",
        },
        {
          date: "08/02/2016",
          subject:
            "Building Height on average width of means of accessCircular No. 11 of 2015-16",
          fileStoreId: "5774137d-2386-4aea-8582-d962c6ebf358",
          label: "DG(BLDG)'s Circular No. 11 of 2015-16",
        },
        {
          date: "18/01/2016",
          subject:
            "NOC for Height clearance from Airport Authority of India Circular No. 10 of 2015-16",
          fileStoreId: "d0535762-3888-457e-bb2f-a04bdfa907c6",
          label: "DG(BLDG)'s Circular No. 10 of 2015-16",
        },
        {
          date: "10/12/2015",
          subject:
            "Fees for additional FAR under rule 69A Circular No. 9 of 2015-16",
          fileStoreId: "466a808d-c615-4c5e-8e30-a4a7f63e98a9",
          label: "DG(BLDG)'s Circular No. 9 of 2015-16",
        },
        {
          date: "10/10/2015",
          subject:
            "Designated agencies for Green Building certification and rates for additional FAR UR 69A Circular No. 7 of 2015-16",
          fileStoreId: "fc572de1-4acc-4d17-b856-7105ae993490",
          label: "DG(BLDG)'s Circular No. 7 of 2015-16",
        },
        {
          date: "22/09/2015",
          subject:
            "NOC from KMRCL for East West metro corridore Circular No. 6 of 2015-16",
          fileStoreId: "fa333331-544d-44ac-b038-e9a2c52ef75d",
          label: "DG(BLDG)'s Circular No. 6 of 2015-16",
        },
        {
          date: "12/09/2015",
          subject:
            "Concent of Education Dept, KMC before sanction of building plan for enclosed premises Circular No. 5 of 2015-16",
          fileStoreId: "055480ce-32de-4f1c-96aa-5c83b09d01ca",
          label: "DG(BLDG)'s Circular No. 5 of 2015-16",
        },
        {
          date: "9/09/2015",
          subject:
            "Charging facility to be provided for electric and hybrid vehicles Circular No. 4 of 2015-16",
          fileStoreId: "d785bcdf-479c-4302-8608-46f651286e0d",
          label: "DG(BLDG)'s Circular No. 4 of 2015-16",
        },
        {
          date: "22/04/2015",
          subject:
            "Office order of MC to deal the encroachment of KMC road or land during issuance of SOR Circular No. 1 of 2015-16",
          fileStoreId: "6c2acc3d-28bd-467c-8a27-aa71c4f9f137",
          label: "DG(BLDG)'s Circular No. 1 of 2015-16",
        },
      ]}
      columnNo={3}
      leftMenuList={BuildingCircularSiteMenuList}
      title="Circular :: 2015-16"
      longMenuList={true}
    />
  );
}

export default Building_Sanction_Circular_2015_16;
